import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Home from "./Pages/Home/Home";
import { ProjectDetail } from "./Pages/Projects/Project";

function App() {

  return (
    <Router> 
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/project/:title" element={<ProjectDetail/>} />
      </Routes>
    </Router> 
  );
}

export default App;
